import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import logo from '../assets/img/logo-horizontal.png';

const UploadLogo = (): ReactElement => {
    const { t } = useTranslation();

    return (
        <div className="text-xs font-medium">
            {t('poweredBy')}
            <a href="https://greenfly.com" target="_blank" rel="noopener noreferrer">
                <img className="w-20 md:w-24 ml-2 inline-block align-middle rtl:ml-0 rtl:mr-2" src={logo} alt="Greenfly"/>
            </a>
        </div>
    );
};

export default UploadLogo;
